import { EstadoIncidenciaIA } from "../shared/model/iso42001/incidencia-ia.model";

export interface IncidenciaIAOption {
  value: string;
  label: string;
  description?: string;
}

export interface IncidenciaIAColumn {
  estado: EstadoIncidenciaIA;
  titulo: string;
  icon: string;
  color: string;
}

export const INCIDENCIA_IA_COLUMNS: IncidenciaIAColumn[] = [
  { estado: "ABIERTO", titulo: "Abierto", icon: "mark_email_unread", color: "#b71c1c" },
  { estado: "PROCESO", titulo: "Proceso", icon: "settings_applications", color: "#ef6c00" },
  { estado: "ATENDIDO", titulo: "Atendido", icon: "fact_check", color: "#1976d2" },
  { estado: "VOBO", titulo: "Vo.Bo.", icon: "task_alt", color: "#2e7d32" },
];

export const TIPO_EVENTO_OPTIONS: IncidenciaIAOption[] = [
  { value: "Error funcional", label: "Error funcional" },
  { value: "Vulnerabilidad de seguridad", label: "Vulnerabilidad de seguridad" },
  { value: "Uso indebido de informacion", label: "Uso indebido de información" },
  { value: "Resultado inexacto", label: "Resultado inexacto" },
  { value: "Incidente operativo", label: "Incidente operativo" },
  { value: "Acceso no autorizado", label: "Acceso no autorizado" },
];

export const GRAVEDAD_OPTIONS: IncidenciaIAOption[] = [
  {
    value: "Critico",
    label: "Crítico",
    description:
      "El usuario no puede desarrollar sus funciones y no existen alternativas de operación disponibles.",
  },
  {
    value: "Medio",
    label: "Medio",
    description:
      "La función no realiza lo que debe realizar, pero existen alternativas de operación.",
  },
  {
    value: "Bajo",
    label: "Bajo",
    description:
      "Hay pérdida parcial de funciones del negocio y existen alternativas.",
  },
];

export const PRIORIDAD_OPTIONS: IncidenciaIAOption[] = [
  {
    value: "Alta",
    label: "Alta",
    description: "Requiere atención inmediata para evitar impacto grave en el negocio.",
  },
  {
    value: "Media",
    label: "Media",
    description: "Es importante, pero permite un poco más de tiempo para su resolución.",
  },
  {
    value: "Baja",
    label: "Baja",
    description: "Se atiende al finalizar el trabajo más importante; aplica a incidentes menores.",
  },
];

export const CARGO_SEGUIMIENTO_OPTIONS: IncidenciaIAOption[] = [
  { value: "Responsable IA", label: "Responsable IA" },
  { value: "Lider Tecnico", label: "Líder Técnico" },
];
